import React from "react";
import {
    makeStyles, withStyles,
    Grid, Dialog, IconButton, Paper, AppBar, Toolbar, Slide,
} from '@material-ui/core';
import { MuiThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import UserProfile from '../../EmployeeRecord/Edit/components/UserProfile'
import ApproverRecord from './components/ApproverRecord';
import UserProfileCollection from '../../../Function/UserProfileCollection'
import customAxios from "../../../API/customAxios";
import { mobileTheme, globalDialogStyle, adminDialogStyle } from "../../../UIComponent/CommonStyle"

const thisTheme = responsiveFontSizes(mobileTheme);

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...adminDialogStyle(theme),
}));

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#f0f2f5',
    },
}))(MuiDialogContent);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Index({ handleClose, open, showId, updateApproverRecord, backToTable }) {
    const classes = useStyles();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [userProfile, setUserProfile] = React.useState({});

    React.useEffect(() => {
        customAxios.get(`/get_employee_approver/` + showId)
            .then(res => {
                var getAllowanceRecord = res.data;
                setUserProfile(UserProfileCollection(getAllowanceRecord));
                setShowCompetent(true);
            })
    }, []);

    return (
        <MuiThemeProvider theme={thisTheme}>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: '#f0f2f5',
                        boxShadow: 'none',
                    },
                }}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <React.Fragment>
                        <Grid container spacing={3}>
                            <Grid item md={6} xs={12}>
                                <Paper className={classes.mainPaper}>
                                    {showCompetent ?
                                        <UserProfile
                                            employeeName={userProfile.employeeName}
                                            managerName={userProfile.managerName}
                                            staffNo={userProfile.staffNo}
                                            position={userProfile.position}
                                            mail={userProfile.mail}
                                            staffDuty={userProfile.staffDuty}
                                            entryDate={userProfile.entryDate}
                                            active={userProfile.active}
                                            location={userProfile.location}
                                            department={userProfile.department}
                                        />
                                        :
                                        <div className={classes.circularProgress}>
                                            <CircularProgress />
                                        </div>
                                    }
                                </Paper>
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <Paper className={classes.mainPaper}>
                                    {showCompetent ?
                                        <ApproverRecord
                                            showId={showId}
                                            updateApproverRecord={updateApproverRecord}
                                            backToTable={backToTable}
                                        />
                                        :
                                        <div className={classes.circularProgress}>
                                            <CircularProgress />
                                        </div>
                                    }
                                </Paper>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                </DialogContent>
            </Dialog >
        </MuiThemeProvider>
    );
}
